
import VFormGroup from '~/components/ui/VFormGroup'
import VCheckbox from '~/components/ui/VCheckbox'
import VButton from '~/components/ui/VButton'
import { mapState, mapGetters } from 'vuex'

export default {
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            amount: {
                value: '',
                error: '',
                required: true
            },
            percent: {
                value: '',
                error: '',
                required: true
            },
            period: {
                value: '7 day',
                error: '',
                required: true
            },
            periods: [
                // {
                //     value: '2 day',
                //     title: '2 дня'
                // },
                {
                    value: '7 day',
                    title: '7 дней'
                },
                {
                    value: '1 month',
                    title: '1 месяц'
                }
            ],
            agree1: false,
            agree2: false
        }
    },
    computed: {
        ...mapState('profile', [
            'currentAccount'
        ]),
        ...mapGetters('profile', [
            'role'
        ]),
        fileUrl() {
            return this.serverImage(`${this.project.id}/${this.amount.value.replace(/\s/g, '')}/${this.period.value}`, '/pre-offer-invest-round/')
        },
        percentValue: {
            get() {
                return this.percent.value
            },
            set(value) {
                const numberValue = value === '' ? '' : +value
                const maxPercent = +this.project.interest_rate_to
                const minPercent = +this.project.interest_rate_from
                if (numberValue > maxPercent) {
                    this.percent.error = `Процент не может быть больше ${maxPercent}%`
                } else if (numberValue < minPercent) {
                    this.percent.error = `Процент не может быть меньше ${minPercent}%`
                } else {
                    this.percent.error = ''
                }
                this.percent.value = value
            }
        },
        amountValue: {
            get() {
                return this.amount.value
            },
            set(value) {
                this.amount.error = ''
                if (value) {
                    this.amount.value = parseInt(value.replace(/\s/g, '')).toLocaleString('ru')
                    const amount = parseInt(value.replace(/\s/g, ''));
                    if(amount % 1000){
                        this.amount.error = 'Сумма должна быть кратна 1000';
                    } else if (amount < this.project.sum_min) {
                        this.amount.error = `Сумма не может быть менее ${this.project.sum_min.toLocaleString('ru')}`;
                    } else if (amount > this.project.sum_max) {
                        this.amount.error = `Сумма не может быть более ${this.project.sum_max.toLocaleString('ru')}`;
                    }
                } else {
                    this.amount.value = value
                }
            }
        },
        canOpenRound(){
            return this.amount.value.length &&
                   this.period.value.length &&
                   this.percent.value.length &&
                   !this.amount.error &&
                   !this.period.error &&
                   !this.percent.error &&
                   this.agree1 && this.agree2
        },
        agreeText() {
            if (this.currentAccount && this.currentAccount.type === 'individual') {
                return 'Настоящим подтверждаю актуальность и достоверность информации об индивидуальном предпринимателе и инвестиционном предложении, а также соответствие индивидуального предпринимателя требованиям Правил.'
            }
            return 'Настоящим подтверждаю актуальность и достоверность информации об организации и инвестиционном предложении, а также соответствие организации требованиям Правил.'
        },
    },
    methods: {
        editProject() {
            this.$router.push({ name: 'profile-application-id-edit', params: { id: this.project.id } });
        },
        deleteOrder() {
            this.$axios.delete(`/intellectual-property/application/${this.project.id}/delete`).then((res) => {
                this.$notify({
                    type: 'success',
                    title: res.data.message,
                })
                this.$router.push({
                    name: 'profile-my-orders'
                })
            })
        },
        async confirmSms(order) {
            const res = await this.$axios.post(`/intellectual-property/application/invest-round/sms-verify`, {
                applicationId: order.applicationId,
                code: order.code
            })
            return res
        },
        openRoundModal() {
            const documents = this.project.with_pledge ? [{
                name: 'Индивидуальные условия Договора займа',
                link: this.fileUrl
            }, {
                name: 'Индивидуальные условия Договора залога',
                link: this.serverImage(this.project.id, '/pre-pledge-offer/')
            }] : [{
                name: 'Индивидуальные условия Договора займа',
                link: this.fileUrl
            }];
            this.$modal.show('sms-confirm', {
                title: 'Открыть раунд',
                sendCode: this.enterCodeRound,
                getCode: this.openRound,
                disableAutoGet: true,
                name: 'smsOpenRound',
                width: 280,
                documents
            })
        },
        async enterCodeRound(code) {
            const data = {
                applicationId: this.project.id,
                code: parseInt(code, 10),
            }
            const token = await this.confirmSms(data)
            this.$modal.hide()
            this.$router.push({
                name: 'profile-my-orders'
            })
            return token
        },
        async startRound(order) {
            const res = await this.$axios.post(`/intellectual-property/application/invest-round`, {
                applicationId: order.applicationId,
                sum: order.sum,
                time: order.time,
                fixedInterestRate: order.fixedInterestRate
            })
            return res
        },
        async openRound() {
            const form = {}
            this.errorMessage = ''

            form.applicationId = this.project.id;
            form.sum = parseInt(this.amount.value.replace(/\s/g, ''));
            form.time = this.period.value;
            form.fixedInterestRate = +this.percent.value;
            let response = this.startRound(form)
                .then((res) => {
                    this.openRoundModal()
                    return res
                })
                .catch((err) => {
                    if (
                        err.response.data.error === 'has_opened_finance_round'
                    ) {
                        this.$modal.show('default-modal', {
                            title: `Внимание!`,
                            maxWidth: 620,
                            content: {
                                component: () => import('~/components/common/DialogModalContent.vue'),
                                props: {
                                    description: 'У вас уже есть заявка, находящаяся в раунде финансирования. Для начала сбора средств по новой заявке, необходимо завершить активный раунд финансирования.',
                                    buttons: [{
                                        title: 'ОК',
                                        width: '200px',
                                        handler: () => {
                                            this.$modal.hide('default-modal')
                                        }
                                    }],
                                }
                            }
                        })
                    } else if (err.response.data.errors && err.response.data.errors.application) {
                        this.amount.error = err.response.data.errors.application;
                    } else if (err.response.data.error_message) {
                        this.$notify({
                            type: 'error',
                            title: err.response.data.error_message
                        })
                    }
                    return err
                })
            return response
        },
    },
    components: {
        VFormGroup,
        VCheckbox,
        VButton
    }
}
